import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import enLocale from 'element-ui/lib/locale/lang/en' //引入Element UI的英文包
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
// 由于vue响应式机制，无法触发检测数组变更
// 需要国际化的数组可以采用监听函数手动重新赋值
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//引入Vue国际化
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
    //Element添加国际化
Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value)
});
//国际化
const i18n = new VueI18n({
    locale: window.localStorage.getItem('I18n')||'zh-CN', // 语言标识, 通过切换locale的值来实现语言切换,this.$i18n.locale
    messages: {
        //导入国际化语言文件，并且添加Element语音包
        'zh-CN': Object.assign(require('./zh'), zhLocale), // 中文语言包
        'zh-TW': Object.assign(require('./zh_tw'), zhLocale), // 中文语言包
        'en-US': Object.assign(require('./en'), enLocale), // 英文语言包
    }
})

export default i18n
